import { ApiAccountDashboardStrategy } from 'api/rtk-api'
import { inRange } from 'lodash'

export const formatStrategy = (strategy: ApiAccountDashboardStrategy) =>
  strategy.trades.reduce(
    (acc, trade) => {
      const { leverageRatio, protectedPercentage, targetVolatility } = trade

      const leverageRatioNumber = Number(leverageRatio)
      const protectedPercentageNumber = Number(protectedPercentage || 0) * 100
      const targetVolatilityNumber = Number(targetVolatility || 0) * 100

      if (inRange(leverageRatioNumber, 1, 1.25)) acc.leverageRatios[0].y += 1
      if (inRange(leverageRatioNumber, 1.25, 1.5)) acc.leverageRatios[1].y += 1
      if (inRange(leverageRatioNumber, 1.5, 1.75)) acc.leverageRatios[2].y += 1
      if (inRange(leverageRatioNumber, 1.75, 2)) acc.leverageRatios[3].y += 1
      if (inRange(leverageRatioNumber, 2, 2.25)) acc.leverageRatios[4].y += 1
      if (inRange(leverageRatioNumber, 2.25, 2.5)) acc.leverageRatios[5].y += 1
      if (inRange(leverageRatioNumber, 2.5, 2.75)) acc.leverageRatios[6].y += 1
      if (inRange(leverageRatioNumber, 2.75, 3) || leverageRatioNumber === 3)
        acc.leverageRatios[7].y += 1

      if (inRange(protectedPercentageNumber, 60, 65)) acc.protectionLevels[0].y += 1
      if (inRange(protectedPercentageNumber, 65, 70)) acc.protectionLevels[1].y += 1
      if (inRange(protectedPercentageNumber, 70, 75)) acc.protectionLevels[2].y += 1
      if (inRange(protectedPercentageNumber, 75, 80)) acc.protectionLevels[3].y += 1
      if (inRange(protectedPercentageNumber, 80, 85)) acc.protectionLevels[4].y += 1
      if (inRange(protectedPercentageNumber, 85, 90)) acc.protectionLevels[5].y += 1
      if (inRange(protectedPercentageNumber, 90, 95)) acc.protectionLevels[6].y += 1
      if (inRange(protectedPercentageNumber, 95, 100) || protectedPercentageNumber === 100)
        acc.protectionLevels[7].y += 1

      if (inRange(targetVolatilityNumber, 5, 10)) acc.targetVolatilities[0].y += 1
      if (inRange(targetVolatilityNumber, 10, 15)) acc.targetVolatilities[1].y += 1
      if (inRange(targetVolatilityNumber, 15, 20)) acc.targetVolatilities[2].y += 1
      if (inRange(targetVolatilityNumber, 20, 25)) acc.targetVolatilities[3].y += 1
      if (inRange(targetVolatilityNumber, 25, 30) || targetVolatilityNumber === 100)
        acc.targetVolatilities[4].y += 1

      return acc
    },
    {
      leverageRatios: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 3, y: 0 },
        { x: 4, y: 0 },
        { x: 5, y: 0 },
        { x: 6, y: 0 },
        { x: 7, y: 0 }
      ],
      protectionLevels: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 3, y: 0 },
        { x: 4, y: 0 },
        { x: 5, y: 0 },
        { x: 6, y: 0 },
        { x: 7, y: 0 }
      ],
      targetVolatilities: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 3, y: 0 },
        { x: 4, y: 0 }
      ]
    }
  )
